import {UserInputType} from '../../../../constants/stores';
import {RootStore} from '../../stores/RootStore';
import {ValidationResult} from '../../../../types/type';

export const getTextFieldValidation = (rootStore: RootStore, textFieldIndex: number): ValidationResult => {
  const {isProductSubmitted, userInputErrors} = rootStore.$state;
  const isError = isProductSubmitted && userInputErrors[UserInputType.Text][textFieldIndex];
  return {isError, errorMessage: rootStore.t.productPage.customTextWidget.errorMessage.requiredField()};
};
